import React, { useEffect, useState } from "react";
import {
  Image,
  Button,
  Descriptions,
  Divider,
  Tag,
  Tabs,
  Select,
  Table,
  Form,
  Input,
} from "antd";
import { AutoComplete, message } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { getDataDoc, updateDocDatabase } from "../database";
import dayjs from "dayjs";
import { collection, getDocs, addDoc, query, where } from "firebase/firestore";
import { openErrorNotification } from "./Notifications/errorNotification";

import { DatePicker, Space } from "antd";
import { db } from "../database/firebase";
import ModalTransfer from "./ModalTransfer";
import { useSelector } from "react-redux";
import {
  createUserWithEmailAndPassword,
  getAuth,
  signOut,
  updateProfile,
} from "firebase/auth";
import { initializeApp } from "firebase/app";
import {
  useWindowSize,
  useWindowWidth,
  useWindowHeight,
} from "@react-hook/window-size";

function generateSixDigitCode() {
  return Math.floor(100000 + Math.random() * 900000);
}
function EditElev({ elevData, setMode, clase, colors, setElevData, id }) {
  const [numeDeFamilie, setNumeDeFamilie] = useState();
  const [prenume, setPrenume] = useState();
  const [adresaEmail, setAdresaEmail] = useState();
  const onlyWidth = useWindowWidth();
  const [clasa, setClasa] = useState();
  const [numarMatricol, setNumarMatricol] = useState();
  const [open, setOpen] = useState(false);
  const [parintii, setParintii] = useState();
  const [promiss, setPromiss] = useState();
  const [vaApareaLaExport, setVaApareaLaExport] = useState(true);
  const [numarTelefon, setNumarTelefon] = useState();
  const [premiu, setPremiu] = useState("");
  const [profindr, setProfindr] = useState();
  const [insprin, setInsprin] = useState();
  const [scutitMedical, setScutitMedical] = useState("");
  const [dataExpirareMedical, setDataExpirareMedical] = useState("");
  const [ces, setCes] = useState("");

  const [religie, setReligie] = useState("da");
  const [cerereReligie, setCerereReligie] = useState("");
  const [inssec, setInssec] = useState();
  const profesori = useSelector((state) => state.profesori);
  const [cnp, setCnp] = useState("");
  const [loculNasteri, setLoculNasteri] = useState("");
  const [tata, setTata] = useState("");
  const [mama, setMama] = useState("");
  const [domiciliu, setDomiciliu] = useState("");
  const [details, setDetails] = useState("");
  const [stareaLaIncheiereaCursurilor, setStareaLaIncheiereaCursurilor] =
    useState("");
  const [stareaLaFinalulAnului, setStareaLaFinalulAnului] = useState("");

  const [materiiSpecialitate, setMateriiSpecialitate] = useState([]);
  const materiiRedux = useSelector((state) => state.materii);
  const [bursa, setBursa] = useState("-");
  const [initiala, setInitiala] = useState("");
  const [options, setOptions] = useState([]);
  const [input, setInput] = useState("");

  useEffect(() => {
    const fetchOptions = async () => {
      const snapshot = await getDocs(collection(db, "optiuni"));
      const data = snapshot.docs.map((doc) => doc.data().value);
      setOptions(data);
    };
    fetchOptions();
  }, []);
  const handleSelect = (value) => {
    setInput(value);
    setPremiu(value);
  };

  const handleSearch = (value) => {
    setInput(value);
    setPremiu(value);
  };
  const handleBlur = async () => {
    if (input && !options.includes(input)) {
      try {
        const existing = await getDocs(
          query(collection(db, "optiuni"), where("value", "==", input))
        );
        if (existing.empty) {
          await addDoc(collection(db, "optiuni"), { value: input });
          setOptions((prev) => [...prev, input]);
          message.success(`Adăugat: ${input}`);
        }
      } catch (err) {
        message.error("Eroare la salvarea opțiunii.");
      }
    }
  };
  useEffect(() => {
    setNumeDeFamilie(elevData.numeDeFamilie || "");
    setPrenume(elevData.prenume || "");
    setAdresaEmail(elevData?.adresaEmail || "");
    setNumarMatricol(elevData.numarMatricol || "");
    setNumarTelefon(elevData.numarTelefon || "");
    setParintii(elevData.parintii || []);
    setClasa(elevData.clasa || "N/A");
    setCnp(elevData.cnp || "");
    setDetails(elevData.details || "");
    setLoculNasteri(elevData.loculNasteri || "");
    setPremiu(elevData.premiu || "");
    setMama(elevData.mama || "");
    setTata(elevData.tata || "");
    setInitiala(elevData.initiala || "");
    setDomiciliu(elevData.domiciliu || "");
    setProfindr(elevData.profindr || "");
    setInsprin(elevData.insprin || "");
    setInssec(elevData.inssec || "");
    setBursa(elevData.bursa || "");
    setScutitMedical(elevData.scutitMedical || "nu");
    setMateriiSpecialitate(elevData.materiiSpecialitate || []);
    setDataExpirareMedical(
      elevData.dataExpirareMedical ? new Date(elevData.dataExpirareMedical) : ""
    );
    setCes(elevData.ces || "nu");
    setReligie(elevData.religie || "da");
    setCerereReligie(elevData.cerereReligie || "");
    setStareaLaIncheiereaCursurilor(
      elevData.stareaLaIncheiereaCursurilor || ""
    );
    setStareaLaFinalulAnului(elevData.stareaLaFinalulAnului || "");
  }, [elevData]);

  const getUserIdByEmail = async (email) => {
    try {
      // Creează o interogare pentru a căuta documentul utilizatorului după email
      const q = query(
        collection(db, "users"),
        where("emailParinte", "==", email)
      );

      // Execută interogarea
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        // Dacă există un document, returnăm `uid` din primul document găsit
        const userDoc = querySnapshot.docs[0];
        const userData = userDoc.data();

        console.log("User ID găsit:", userDoc.id); // `userDoc.id` este `uid` al utilizatorului
        return userDoc.id; // Returnăm `userId` (document ID)
      } else {
        console.log("Nu am găsit niciun utilizator cu acest email.");
        return null;
      }
    } catch (error) {
      console.error("Eroare la căutarea utilizatorului:", error);
      return null;
    }
  };

  // Funcție pentru actualizarea documentelor profesorilor
  const updateProfesoriDocuments = async (
    materiiVechi,
    materiiNoi,
    elevId,
    clasa
  ) => {
    try {
      // Calculează numărul de instanțe pentru fiecare profesor în materiile vechi și noi
      const countProfessorInstances = (materii) => {
        const counts = {};
        (materii || []).forEach((m) => {
          (m.profesori || []).forEach((profId) => {
            counts[profId] = (counts[profId] || 0) + 1;
          });
        });
        return counts;
      };

      const profesoriVechiCounts = countProfessorInstances(materiiVechi);
      const profesoriNoiCounts = countProfessorInstances(materiiNoi);

      // Pentru fiecare profesor, calculează diferența de instanțe
      const allProfessors = [
        ...new Set([
          ...Object.keys(profesoriVechiCounts),
          ...Object.keys(profesoriNoiCounts),
        ]),
      ];

      for (const profesorId of allProfessors) {
        const vechiCount = profesoriVechiCounts[profesorId] || 0;
        const noiCount = profesoriNoiCounts[profesorId] || 0;
        const diferenta = noiCount - vechiCount;

        const profesorData = await getDataDoc("users", profesorId);
        let claseExistente = profesorData?.clase || [];

        if (diferenta > 0) {
          // Adaugă instanțe noi ale clasei
          for (let i = 0; i < diferenta; i++) {
            claseExistente.push(clasa);
          }
          await updateDocDatabase("users", profesorId, {
            clase: claseExistente,
          });
        } else if (diferenta < 0) {
          // Șterge instanțe ale clasei
          for (let i = 0; i < Math.abs(diferenta); i++) {
            const indexToRemove = claseExistente?.findIndex((c) => c === clasa);
            if (indexToRemove !== -1) {
              claseExistente.splice(indexToRemove, 1);
            }
          }
          await updateDocDatabase("users", profesorId, {
            clase: claseExistente,
          });
        }
      }
    } catch (error) {
      console.error("Eroare la actualizarea documentelor profesorilor:", error);
    }
  };

  const onSave = async () => {
    try {
      let elevData = await getDataDoc("elevi", id);

      // Salvează materiile vechi pentru comparare
      const materiiVechi = elevData?.materiiSpecialitate || [];
      const firebaseConfig = {
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_FIREBASE_APP_ID,
      };
      if (adresaEmail !== elevData.email) {
        const firebaseConfig = {
          apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
          authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
          projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
          storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
          messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
          appId: process.env.REACT_APP_FIREBASE_APP_ID,
        };
        let Secondary = initializeApp(firebaseConfig, "secondary");
        let auth2 = getAuth(Secondary);
      }

      let docBoss = await getDataDoc("elevi", id);
      if (docBoss?.parintii) {
        // Iterează prin lista de părinți din documentul elevului
        for await (let parinte of docBoss.parintii) {
          if (!parintii?.find((p) => p === parinte)) {
            // Găsește userId-ul pe baza emailului părintelui
            const userId = await getUserIdByEmail(parinte);

            if (userId) {
              // Obține documentul utilizatorului
              const dataParinte = await getDataDoc("users", userId);

              if (dataParinte?.copii) {
                // Filtrează câmpul copii pentru a elimina elevul
                const copiiActualizati = dataParinte?.copii?.filter(
                  (copil) => copil.idElev !== id
                );
                const eleviA = dataParinte?.elevi?.filter(
                  (copil) => copil !== id
                );

                // Actualizează documentul utilizatorului în Firestore
                await updateDocDatabase("users", userId, {
                  copii: copiiActualizati || [],
                  elevi: eleviA || [],
                });

                console.log(
                  `Elevul ${id} a fost eliminat din documentul părintelui ${userId}.`
                );
              }
            }
          }
        }
      }

      setElevData({
        ...elevData,
        numeDeFamilie,
        prenume,
        adresaEmail,
        numarMatricol,
        numarTelefon,
        displayName: numeDeFamilie + " " + initiala + " " + prenume,
        parintii,
        clasa,

        cnp,
        details,
        materiiSpecialitate,
        initiala,
        insprin,
        inssec,
        profindr,
        loculNasteri,
        mama,
        tata,
        domiciliu,
        premiu,
        bursa,
        scutitMedical,
        dataExpirareMedical: dataExpirareMedical
          ? dataExpirareMedical.getTime()
          : "",
        ces,
        religie,
        cerereReligie,
        stareaLaIncheiereaCursurilor,
        stareaLaFinalulAnului,
      });
      await updateDocDatabase("elevi", id, {
        ...elevData,
        numeDeFamilie,
        prenume,
        adresaEmail,
        numarMatricol,
        numarTelefon,
        displayName: numeDeFamilie + " " + initiala + " " + prenume,
        parintii,
        initiala,
        insprin,
        inssec,
        profindr,
        details,
        materiiSpecialitate,
        clasa,
        cnp,
        loculNasteri,
        mama,
        tata,
        domiciliu,
        premiu,
        bursa,
        scutitMedical,
        dataExpirareMedical: dataExpirareMedical
          ? dataExpirareMedical.getTime()
          : "",
        ces,
        religie,
        cerereReligie,
        stareaLaIncheiereaCursurilor,
        stareaLaFinalulAnului,
      });
      await updateDocDatabase("users", id, {
        numeDeFamilie,
        prenume,
        displayName: numeDeFamilie + " " + initiala + " " + prenume,
      });
      const data = await getDataDoc("claseData", elevData.clasa);
      let elevi = (data?.elevi || [])?.filter((el) => el.id !== id);
      const { transferuri } = await getDataDoc("elevi", id);

      await updateDocDatabase("claseData", elevData.clasa, {
        elevi: [
          ...elevi,
          {
            id,
            numeDeFamilie,
            prenume,
            adresaEmail,
            parintii,
            initiala,
            scutitMedical,
            dataExpirareMedical: dataExpirareMedical
              ? dataExpirareMedical.getTime()
              : "",
            ces,
            details,
            materiiSpecialitate,
            religie,
            cerereReligie,
            transferuri: transferuri || [],
          },
        ],
      });

      // Actualizează documentele profesorilor pentru materiile specializate
      await updateProfesoriDocuments(
        materiiVechi,
        materiiSpecialitate,
        id,
        elevData.clasa
      );

      const note = await getDataDoc("catalog", id);
      const docs = await getDataDoc("eleviDocumente", id);
      if (clasa !== elevData.clasa) {
        if (vaApareaLaExport) {
          // If va aparea la export, keep with gradesFrozen and docsFrozen
          await updateDocDatabase("claseData", elevData.clasa, {
            elevi: [
              ...elevi.filter((el) => el.id !== id),
              {
                id,
                numeDeFamilie,
                prenume,
                adresaEmail,
                parintii,
                initiala,
                scutitMedical,
                dataExpirareMedical: dataExpirareMedical
                  ? dataExpirareMedical.getTime()
                  : "",
                ces,
                religie,
                cerereReligie,
                transferuri,
                mutat: true,
                gradesFrozen: note?.note || [],
                docsFrozen: docs || [],
              },
            ],
          });
        } else {
          // If nu va aparea la export, remove completely from old class
          await updateDocDatabase("claseData", elevData.clasa, {
            elevi: elevi.filter((el) => el.id !== id),
          });
        }
        const data = await getDataDoc("claseData", clasa);
        let newelevi = data?.elevi || [];
        await updateDocDatabase("claseData", clasa, {
          elevi: [
            ...newelevi,
            {
              id,
              numeDeFamilie,
              prenume,
              adresaEmail,
              parintii,
              initiala,
              clasaVeche: elevData.clasa,
            },
          ],
        });
      }

      for await (let email of parintii) {
        let pass = generateSixDigitCode();

        let Secondary = initializeApp(firebaseConfig, "secondary");
        let auth2 = getAuth(Secondary);
        try {
          await createUserWithEmailAndPassword(auth2, email, pass).then(
            async (userCredentials) => {
              const user = userCredentials.user;
              await updateDocDatabase(
                "mail",
                "utilizator" + pass + Date.now(),
                {
                  to: [email].filter(e => e && !e.includes("dobriceansoftware")),
                  message: {
                    subject:
                      "Ați fost înregistrat ca utilizator abonat pentru elevul " +
                      numeDeFamilie +
                      " " +
                      prenume,
                    html: `
                    <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; background-color: #f8f9fa;">
                      <div style="background-color: #ffffff; border-radius: 10px; padding: 30px; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
                        <div style="text-align: center; margin-bottom: 30px;">
                          <h1 style="color: #2c3e50; margin-bottom: 10px;">👨‍👩‍👧‍👦 Bine ați venit!</h1>
                          <h2 style="color: #34495e; font-weight: normal; margin: 0;">Cont utilizator creat cu succes</h2>
                        </div>
                        
                        <div style="background-color: #e8f4f8; border-left: 4px solid #3498db; padding: 20px; margin: 20px 0; border-radius: 0 5px 5px 0;">
                          <h3 style="color: #2c3e50; margin-top: 0;">Stimate utilizator,</h3>
                          <p style="color: #34495e; line-height: 1.6; margin-bottom: 0;">
                            Ați fost înregistrat ca utilizator abonat pentru elevul <strong>${numeDeFamilie} ${prenume}</strong>. 
                            Prin acest cont veți putea urmări progresul școlar al elevului.
                          </p>
                        </div>
                        
                        <div style="background-color: #fff3cd; border: 1px solid #ffeaa7; border-radius: 5px; padding: 20px; margin: 20px 0;">
                          <h3 style="color: #856404; margin-top: 0;">🔑 Datele dumneavoastră de autentificare:</h3>
                          <table style="width: 100%; border-collapse: collapse;">
                            <tr>
                              <td style="padding: 8px 0; color: #495057; font-weight: bold;">Email:</td>
                              <td style="padding: 8px 0; color: #212529; font-family: 'Courier New', monospace;">${email}</td>
                            </tr>
                            <tr>
                              <td style="padding: 8px 0; color: #495057; font-weight: bold;">Parolă temporară:</td>
                              <td style="padding: 8px 0; color: #212529; font-family: 'Courier New', monospace; font-weight: bold;">${pass}</td>
                            </tr>
                          </table>
                        </div>
                        
                        <div style="text-align: center; margin: 30px 0;">
                          <a href="${
                            process.env.REACT_APP_LINK
                          }?email=${encodeURIComponent(email)}&pass=${pass}" 
                             style="display: inline-block; background-color: #e74c3c; color: white; padding: 12px 30px; text-decoration: none; border-radius: 25px; font-weight: bold; box-shadow: 0 3px 6px rgba(231, 76, 60, 0.3);">
                            👤 Accesează contul
                          </a>
                          <div style="margin-top: 15px; padding: 10px; background-color: #f8f9fa; border-radius: 5px;">
                            <p style="color: #6c757d; font-size: 12px; margin: 5px 0;">Dacă butonul nu funcționează, copiați și lipiți acest link în browser:</p>
                            <p style="color: #495057; font-size: 12px; word-break: break-all; margin: 0;">
                              ${
                                process.env.REACT_APP_LINK
                              }?email=${encodeURIComponent(email)}&pass=${pass}
                            </p>
                          </div>
                        </div>
                        
                        <div style="background-color: #f8d7da; border: 1px solid #f5c6cb; border-radius: 5px; padding: 15px; margin: 20px 0;">
                          <p style="color: #721c24; margin: 0; text-align: center;">
                            <strong>⚠️ Important:</strong> Din motive de securitate, veți fi obligat să vă schimbați parola la prima autentificare.
                          </p>
                        </div>
                        
                        <div style="background-color: #d1ecf1; border: 1px solid #bee5eb; border-radius: 5px; padding: 15px; margin: 20px 0;">
                          <h4 style="color: #0c5460; margin-top: 0;">📊 Ce puteți face cu acest cont:</h4>
                          <ul style="color: #0c5460; margin-bottom: 0; padding-left: 20px;">
                            <li>Vizualizați notele elevului</li>
                            <li>Monitorizați temele și proiectele</li>
                            <li>Primiți notificări despre progresul școlar</li>
                            <li>Comunicați cu profesorii</li>
                          </ul>
                        </div>
                        
                        <div style="border-top: 1px solid #dee2e6; padding-top: 20px; margin-top: 30px; text-align: center;">
                          <p style="color: #6c757d; font-size: 14px; margin: 0;">
                            Pentru orice întrebări sau probleme tehnice, vă rugăm să contactați administratorul școlii.
                          </p>
                        </div>
                      </div>
                    </div>
                  `,
                  },
                }
              );
              await updateProfile(user, { emailVerified: true });
              signOut(auth2);
              await updateDocDatabase("users", user?.uid, {
                reset: true,
                type: "parinte",
                uid: user?.uid,
                emailParinte: email,
                copii: [
                  {
                    adresaEmail,
                    idElev: id,
                    prenume,
                    displayName: numeDeFamilie + " " + initiala + " " + prenume,
                    numeDeFamilie,
                    scutitMedical,
                    dataExpirareMedical: dataExpirareMedical
                      ? dataExpirareMedical.getTime()
                      : "",
                    ces,
                    religie,
                    cerereReligie,
                  },
                ],
                elevi: [id],
              });
            }
          );
        } catch (err) {
          const q = query(
            collection(db, "users"),
            where("emailParinte", "==", email)
          );
          let data = undefined;

          const querySnapshot = await getDocs(q);
          querySnapshot.forEach((doc) => {
            data = doc.data();
          });
          if (data === undefined) {
            // openErrorNotification("nu am gasit cont parinte");
          }
          if (data?.uid)
            await updateDocDatabase("users", data.uid, {
              copii: [
                ...(data.copii || []).filter((e) => e.idElev !== id),
                {
                  adresaEmail,
                  idElev: id,
                  prenume,
                  displayName: numeDeFamilie + " " + initiala + " " + prenume,
                  scutitMedical,
                  dataExpirareMedical: dataExpirareMedical
                    ? dataExpirareMedical.getTime()
                    : "",
                  ces,
                  religie,
                  cerereReligie,
                  numeDeFamilie,
                },
              ],
              elevi: [...(data.elevi || []).filter((e) => e !== id), id],
            });
        }
      }
    } catch (e) {
      openErrorNotification(e.message);
    }
  };

  return (
    <>
      <ModalTransfer
        open={open}
        setOpen={setOpen}
        elevData={elevData}
        promiss={promiss}
        id={id}
        setClasa={setClasa}
        vaApareaLaExport={vaApareaLaExport}
        setVaApareaLaExport={setVaApareaLaExport}
      />
      <Descriptions
        bordered
        layout={"vertical"}
        column={1}
        title={
          (elevData.numeDeFamilie + " " + initiala + " ",
          elevData.prenume +
            " - " +
            clase?.find((cls) => cls.id === elevData.clasa)?.anClasa +
            " " +
            clase?.find((cls) => cls.id === elevData.clasa)?.identificator)
        }
        extra={[
          <Button
            onClick={() => {
              setMode("view");
            }}
            style={{ marginRight: "10px", color: "red" }}
          >
            Cancel
          </Button>,

          <Button
            type="primary"
            onClick={() => {
              onSave();
              setMode("view");
            }}
          >
            Save
          </Button>,
        ]}
      >
        <Descriptions.Item label="Nume">
          <Input
            value={numeDeFamilie}
            onChange={(e) => {
              setNumeDeFamilie(e.target.value);
            }}
          />
        </Descriptions.Item>
        <Descriptions.Item label="Prenume">
          {" "}
          <Input
            value={prenume}
            onChange={(e) => {
              setPrenume(e.target.value);
            }}
          />
        </Descriptions.Item>
        <Descriptions.Item label="Initiala">
          {" "}
          <Input
            value={initiala}
            onChange={(e) => {
              setInitiala(e.target.value);
            }}
          />
        </Descriptions.Item>
        <Descriptions.Item label="Clase">
          <Select
            value={clasa}
            style={{ width: "100%" }}
            onChange={(e, value) => {
              setPromiss(value.value);
              setOpen(true);
            }}
            options={[
              ...clase.map((cls) => {
                return {
                  label: cls.anClasa + cls.identificator,
                  value: cls.id,
                };
              }),

              { label: "N/A", value: "faraclasa" },
            ]}
          />
        </Descriptions.Item>
        <Descriptions.Item label="Nr. Matricol (nr/vol/p)">
          <Input
            value={numarMatricol}
            onChange={(e) => {
              setNumarMatricol(e.target.value);
            }}
          />
        </Descriptions.Item>
        <Descriptions.Item label="Nr. Telefon">
          <Input
            value={numarTelefon}
            onChange={(e) => {
              setNumarTelefon(e.target.value);
            }}
          />
        </Descriptions.Item>
        <Descriptions.Item label="CNP">
          <Input
            value={cnp}
            onChange={(e) => {
              setCnp(e.target.value);
            }}
          />
        </Descriptions.Item>
        {process.env.REACT_APP_NAME === "LMTJ" && (
          <Descriptions.Item label="Prof. Indr">
            <Input
              value={profindr}
              onChange={(e) => {
                setProfindr(e.target.value);
              }}
            />
          </Descriptions.Item>
        )}
        {process.env.REACT_APP_NAME === "LMTJ" && (
          <Descriptions.Item label="Ins. Prin.">
            <Input
              value={insprin}
              onChange={(e) => {
                setInsprin(e.target.value);
              }}
            />
          </Descriptions.Item>
        )}
        {process.env.REACT_APP_NAME === "LMTJ" && (
          <Descriptions.Item label="Ins. Sec.">
            <Input
              value={inssec}
              onChange={(e) => {
                setInssec(e.target.value);
              }}
            />
          </Descriptions.Item>
        )}
        <Descriptions.Item label="Premiu">
          {process.env.REACT_APP_NAME === "LMTJ" && (
            <AutoComplete
              value={premiu}
              options={options.map((opt) => ({ value: opt }))}
              style={{ width: "100%" }}
              onSelect={handleSelect}
              onSearch={handleSearch}
              onBlur={handleBlur}
            >
              <Input placeholder="Scrie sau selectează o opțiune" />
            </AutoComplete>
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Domicliu">
          <Input
            value={domiciliu}
            onChange={(e) => {
              setDomiciliu(e.target.value);
            }}
          />
        </Descriptions.Item>

        <Descriptions.Item label="Prenume Mama">
          <Input
            value={mama}
            onChange={(e) => {
              setMama(e.target.value);
            }}
          />
        </Descriptions.Item>
        <Descriptions.Item label="Tata">
          <Input
            value={tata}
            onChange={(e) => {
              setTata(e.target.value);
            }}
          />
        </Descriptions.Item>
        <Descriptions.Item label="Cerere Scutire Medicală">
          <Input
            value={scutitMedical}
            onChange={(e) => {
              setScutitMedical(e.target.value);
            }}
          />
        </Descriptions.Item>
        <Descriptions.Item label="Scutit medical">
          <DatePicker
            value={dataExpirareMedical ? dayjs(dataExpirareMedical) : null}
            format={"DD/MM/YYYY"}
            onChange={(e) => {
              setDataExpirareMedical(e.toDate());
            }}
          />
        </Descriptions.Item>
        <Descriptions.Item label="CES">
          <Select
            value={ces}
            onChange={(e) => {
              setCes(e);
            }}
            options={[
              { label: "NU", value: "nu" },
              { label: "DA", value: "da" },
            ]}
          />
        </Descriptions.Item>

        <Descriptions.Item label="Religie">
          <Select
            style={{ width: "100%", minWidth: "200px" }}
            value={religie}
            onChange={(e) => {
              setReligie(e);
            }}
            options={[
              { label: "Face religie", value: "da" },
              { label: "Face religie penticostală", value: "penticostala" },
              { label: "Nu face religie", value: "nu" },
            ]}
          />
        </Descriptions.Item>
        {religie !== "da" && (
          <Descriptions.Item label="Cerere Religie">
            <Input
              value={cerereReligie}
              onChange={(e) => {
                setCerereReligie(e.target.value);
              }}
              placeholder="Detalii cerere religie"
            />
          </Descriptions.Item>
        )}
        <Descriptions.Item label="Bursa">
          <Select
            value={bursa}
            onChange={(e) => {
              setBursa(e);
            }}
            options={[
              { label: "-", value: "-" },
              { label: "nebursier", value: "nebursier" },
              { label: "merit", value: "merit" },
              { label: "sociala", value: "sociala" },
              { label: "performanta", value: "performanta" },
            ]}
          />
        </Descriptions.Item>

        <Descriptions.Item label="Emailuri abonate">
          <Select
            mode="tags"
            value={parintii || []}
            onChange={(e) => setParintii(e.map((item) => item.trim()))}
          />
        </Descriptions.Item>
        <Descriptions.Item label="Detalii" span={"filled"}>
          <Input
            value={details}
            onChange={(e) => {
              setDetails(e.target.value);
            }}
          />
        </Descriptions.Item>
        <Descriptions.Item label="Starea la încheierea cursurilor">
          <Input
            value={stareaLaIncheiereaCursurilor}
            onChange={(e) => {
              setStareaLaIncheiereaCursurilor(e.target.value);
            }}
          />
        </Descriptions.Item>
        <Descriptions.Item label="Starea la finalul anului școlar">
          <Input
            value={stareaLaFinalulAnului}
            onChange={(e) => {
              setStareaLaFinalulAnului(e.target.value);
            }}
          />
        </Descriptions.Item>

        <Descriptions.Item label="Materii specialitate">
          <span>
            {materiiSpecialitate.map((materie, index) => {
              return (
                <>
                  <div
                    style={{
                      display: "block",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <Select
                      showSearch
                      style={{ width: "90%" }}
                      placeholder="Materie"
                      optionFilterProp="children"
                      value={materie.materie}
                      onChange={(value) => {
                        let subjects = JSON.parse(
                          JSON.stringify(materiiSpecialitate)
                        );
                        subjects[index].materie = value;
                        setMateriiSpecialitate(subjects);
                      }}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input?.toLowerCase())
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      options={materiiRedux
                        .filter((mat) => mat.orar !== true || mat.id === materie.materie) // Exclude materiile cu orar: true DACĂ nu e materia selectată
                        .map((mat) => {
                          return {
                            label: mat?.numeMaterie + "-" + mat?.profil,
                            value: mat?.id,
                          };
                        })}
                    />
                    <Select
                      mode="multiple"
                      style={{ width: "90%" }}
                      showSearch
                      placeholder="Profesor"
                      optionFilterProp="children"
                      value={materie.profesori}
                      onChange={(value) => {
                        let subjects = JSON.parse(
                          JSON.stringify(materiiSpecialitate)
                        );
                        subjects[index].profesori = value;
                        setMateriiSpecialitate(subjects);
                      }}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input?.toLowerCase())
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      options={(
                        materiiRedux.find((mat) => mat.id === materie?.materie)
                          ?.profesori || []
                      ).map((profID) => {
                        let prof = profesori?.find((pf) => pf.id === profID);
                        return {
                          label: prof?.numeDeFamilie + "-" + prof?.prenume,
                          value: prof?.id,
                        };
                      })}
                    />
                    <Button
                      icon={<DeleteOutlined />}
                      danger
                      onClick={() => {
                        setMateriiSpecialitate(
                          materiiSpecialitate.filter(
                            (ma) => ma.materie !== materie?.materie
                          )
                        );
                      }}
                    />
                  </div>
                  <br />
                </>
              );
            })}
            <Button
              onClick={() => {
                setMateriiSpecialitate([
                  ...materiiSpecialitate,
                  { materie: "" },
                ]);
              }}
            >
              <PlusOutlined />
            </Button>
          </span>
        </Descriptions.Item>
      </Descriptions>
      <Button
        type="primary"
        style={{ width: "100%" }}
        onClick={() => {
          onSave();
          setMode("view");
        }}
      >
        Save
      </Button>
    </>
  );
}

export default EditElev;
